import Receipt from "./View";
import ReceiptContainer from "./Container";

export { Receipt };
export default  ReceiptContainer;